var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-drawer',{attrs:{"size":'500px',"direction":"rtl","title":"审批详情","visible":_vm.processVisible},on:{"update:visible":function($event){_vm.processVisible=$event}}},[(_vm.processVisible)?_c('instance-preview',{attrs:{"instance-id":_vm.selectInstance},on:{"handler-after":function($event){_vm.processVisible = false}}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }